import React from "react";

export interface StoreHours{
    menuDay: string;
    fromTime: string;
    toTime: string;
  }

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  menuschedule: StoreHours[]; 
}

const MenuScheduleFilter: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  menuschedule,
}) => {
  if (!isOpen) return null;
 const formatTime = (time: string | null): string => {
   if (!time) {
     return ""; 
   }

 
   const [hours, minutes] = time.split(":").map(Number);
   const date = new Date();
   date.setHours(hours);
   date.setMinutes(minutes);
   date.setSeconds(0);

   
   const localTime = new Date(
     date.getTime()
   );

  
   const localHours = localTime.getHours();
   const localMinutes = localTime.getMinutes();

   
   const period = localHours >= 12 ? "PM" : "AM";
   const hours12 = localHours % 12 || 12;
   const formattedTime = `${hours12}:${
     localMinutes < 10 ? "0" : ""
   }${localMinutes} ${period}`;

   return formattedTime;
 };
  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-50 bg-white/30 dark:bg-black/60"
      onClick={onClose}
    >
      <div
     className="bg-white dark:bg-gray-700  rounded-lg p-2 w-full max-w-sm h-auto overflow-y-auto max-h-full "
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold mt-4  ml-4">Hours:</h3>
     <div className="space-y-2 ml-6 mt-4">
  {Object.entries(
    menuschedule.reduce((acc, curr) => {
      acc[curr.menuDay] = acc[curr.menuDay] || [];
      acc[curr.menuDay].push(curr);
      return acc;
    }, {} as Record<string, StoreHours[]>)
  ).map(([day, entries]) =>
    entries.map((schedule: StoreHours, idx: number) => (
      <div key={`${day}-${idx}`} className="grid grid-cols-3 gap-4">
        <span>{idx === 0 ? day : ''}</span>
        <span>{formatTime(schedule.fromTime)}</span>
        <span>{formatTime(schedule.toTime)}</span>
      </div>
    ))
  )}
</div>
        <div className="flex justify-end mt-4">
          <button
            onClick={onClose}
            className="bg-custom-green text-white font-normal py-2 px-4 rounded"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuScheduleFilter;
